// extracted by mini-css-extract-plugin
export default {"root":"summary-wrap_root__uWiJP","placeHolderShimmer":"summary-wrap_placeHolderShimmer__j1j09"};